import { FC, ReactNode } from "react";
import {
  IoBookOutline,
  IoPersonAddOutline,
  IoCalendarOutline,
  IoPersonCircleOutline,
  IoCameraOutline,
  IoCloudUploadOutline,
  IoImagesOutline,
  IoHelpCircleOutline,
} from "react-icons/io5";

interface CategoriesProps {
  onSelect: (categoryId: number) => void;
}

interface Category {
  id: number;
  title: string;
  icon: ReactNode;
}

const Categories: FC<CategoriesProps> = ({ onSelect }) => {
  const categories: Category[] = [
    {
      id: 1,
      title: "イロドキのはじめ方",
      icon: <IoBookOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 2,
      title: "年度途中の入園・退園",
      icon: <IoPersonAddOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 3,
      title: "新年度準備",
      icon: <IoCalendarOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 4,
      title: "アカウント設定",
      icon: <IoPersonCircleOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 5,
      title: "カメラアプリの使い方",
      icon: <IoCameraOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 6,
      title: "写真の配信方法",
      icon: <IoCloudUploadOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 7,
      title: "配信済写真の活用",
      icon: <IoImagesOutline size={64} color="#9CA3AF" />,
    },
    {
      id: 8,
      title: "その他",
      icon: <IoHelpCircleOutline size={64} color="#9CA3AF" />,
    },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto p-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {categories.map((category) => {
          return (
            <button
              key={category.id}
              className="bg-white rounded-lg flex flex-col justify-center items-center p-8 min-h-[200px]"
              onClick={() => onSelect(category.id)}
            >
              <div className="mb-4">{category.icon}</div>
              <h2 className="text-lg lg:text-xl font-bold text-center text-teal-600 leading-tight">
                {category.title}
              </h2>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Categories;
